<section>
  <div class="main__container">
    <div class="main">
      <div class="main__title">
        <div class="title__left">
          <h1 class="head__one">Claim Submission Summary</h1>
          <div 
          class="status" 
          [ngStyle]="{
              'background-color': 
                  claimDetails.status === 'pending' ? '#34495e ' : 
                  claimDetails.status === 'accepted' ? ' #2ecc71' : 
                  claimDetails.status === 'queried' ? '#f8c805 ' :
                  claimDetails.status === 'rejected' ? '#f8051f ' : 'transparent',
              'color': 'white',
          }"
      >
          Status: {{ claimDetails.status | titlecase }}
      </div>
          <!-- <div class="status">Status: {{ status }}</div> -->
        </div>
      </div>
    </div>

    <div class="claim__summmaryCard">
      <div class="claim__title">
        <span>Claim Details </span>
      </div>
      <div class="claim__detail">
        <div class="claim">
          <div class="claim__subtitle">Claim Number</div>
          <div class="claim__text">{{ claimDetails.claim_number }}</div>
        </div>
        <div class="claim">
            <div class="claim__subtitle">Policy Number</div>
            <div class="claim__text">{{ claimDetails.policy_number }}</div>
          </div>
        <div class="claim">
          <div class="claim__subtitle">Date of Incident</div>
          <div class="claim__text">{{ claimDetails.incident_date | date }}</div>
        </div>
        <div class="claim">
          <div class="claim__subtitle">Claim Amount</div>
          <div class="claim__text">{{ claimDetails.claim_amount }}</div>
        </div>
        <div class="claim">
            <div class="claim__subtitle">Claim Logged Date</div>
            <div class="claim__text">{{ claimDetails.claim_date | date}}</div>
          </div>
        <div class="claim">
          <div class="claim__subtitle">Gross Premium</div>
          <div class="claim__text">{{ claimDetails.gross_premium | currency: '₦ ' }}</div>
        </div>
        <div class="claim">
          <div class="claim__subtitle">Location</div>
          <div class="claim__text">{{ claimDetails.incident_location }}</div>
        </div>
        <div class="claim">
          <div class="claim__subtitle">Travel Package</div>
          <div class="claim__text">{{ claimDetails.package }}</div>
        </div>

      </div>
    </div>
  </div>
</section>
